// extracted by mini-css-extract-plugin
export default {"body":"ReportSection_body__t0SrU","p":"ReportSection_p__X8lkl","wide":"ReportSection_wide__IRlxi"};